/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
import { Box, Grid, Modal, Button } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { BsCloudUploadFill, BsFillGrid3X2GapFill } from "react-icons/bs";
import { FaSearch } from "react-icons/fa";
import { FiX } from "react-icons/fi";

import API from "@unisearch/helpers/api";
import styles from "./MultipleFileInput.module.scss";
import MediaBox from "../media/MediaBox";
import { MediaScreen } from "../loader";
import PaginationComponent from "../ui_element/pagination";
import { MediaUPload } from "../media";

export const MultipleFileInput = ({
  label = "Upload Files",
  allowItem = "image",
  value = [],
  onChange,
}) => {
  const FILES_URL = `/media-manager/find-mediaFile`;

  const [fileData, setFileDate] = useState([]);
  const [selected, setSelected] = useState([]);

  const [open, setOpen] = useState(false);

  //on load or change value set file data
  useEffect(() => {
    setFileDate(value);
  }, [value]);

  //manage popup
  const handleOpen = (value) => {
    setOpen(value);
  };

  //loading and form
  const [loading, setLoading] = useState(false);
  const [is_EnableForm, setEnableForm] = useState(false);

  //get Media Data
  const [mediaData, setMediaData] = useState([]);
  const [paginate, setPaginate] = useState({});

  const paginationHandler = (event, page) => {
    setSearchFields({ ...searchFields, pageNumber: page });
  };

  //search search state
  const [searchFields, setSearchFields] = useState({
    filter: { mediaName: "", alt: "", tag: allowItem },
    sortOrder: "DESC",
    sortField: "mediaManagerId",
    pageNumber: 1,
    pageSize: 10,
  });

  //handle serach input
  const handleInput = (e) => {
    const { name, value } = e.target;
    const filter = { ...searchFields.filter, [name]: value.trim() };
    setSearchFields({ ...searchFields, filter, pageNumber: 1 });
  };

  const handleOrder = (e) => {
    const { name, value } = e.target;
    setSearchFields({ ...searchFields, [name]: value, pageNumber: 1 });
  };

  //HANDLE SERARCH OBJECT
  const handleSearch = async () => {
    //loading true
    setLoading(true);

    //post handle search
    await API.post(`${FILES_URL}`, searchFields)
      .then((response) => {
        if (response.error) {
          swalError("Something Wrong!");
        }

        if (!response.error) {
          const {
            total,
            results,
            currentPage,
            page_total,
            limit,
          } = response.data;

          //set Paginate Info
          setPaginate({ total, currentPage, page_total, limit });

          //set media data
          setMediaData(results);
        }
      })
      .catch((error) => {
        swalError(error);
      });

    //loading false
    setLoading(false);
  };

  const imageChange = (data) => {
    let exist =
      selected &&
      selected.filter((item) => item.mediaManagerId == data.mediaManagerId);
    if (exist && exist.length > 0) {
      setSelected(
        selected.filter((item) => item.mediaManagerId != data.mediaManagerId)
      );
    } else {
      setSelected((prev) => [...prev, data]);
    }
  };

  //insert data
  const handleInsert = (e) => {
    e.preventDefault();
    let returnData =
      selected && selected.length > 0
        ? selected.map((item) => {
            return {
              mediaManagerId: item.mediaManagerId,
              src: item.src,
            };
          })
        : [];
    if (onChange) {
      onChange(returnData);
    }
    setOpen(false);
  };

  useEffect(() => {
    handleSearch();
  }, []);

  //when change page
  useEffect(() => {
    setTimeout(() => {
      handleSearch();
    }, 500);
  }, [searchFields]);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  //when remove item
  const handleRemove = (id) => {
    let returnDate = value.filter((item) => item.mediaManagerId != id);
    if (onChange) {
      onChange(returnDate);
    }
  };

  //get data form child
  const handleUploaded = async (result) => {
    if (result) {
      setEnableForm(false);
      await handleSearch();
    } else {
      swalError("Upload Error");
    }
  };

  return (
    <Fragment>
      <div className={styles.images_wrapper}>
        <label className="admin_label">{label}</label>
        <ul className={styles.upload_images}>
          <li>
            <button
              type="button"
              htmlFor="uploadImage"
              className={`${styles.upload_image_child}`}
              onClick={(e) => {
                handleOpen(true);
              }}
            >
              <img
                src="/assets/images/admin/university/upload_image.jpg"
                alt="Upload Image"
              />
            </button>
          </li>

          {fileData &&
            fileData.length > 0 &&
            fileData.map((item, i) => {
              return (
                <li key={`gallery_img_${i}`}>
                  <button
                    type="button"
                    className={styles.image_delete}
                    onClick={() => handleRemove(item.mediaManagerId)}
                  >
                    <FiX />
                  </button>
                  <img src={item.src} alt={`gallery-image-${i}`} />
                </li>
              );
            })}
        </ul>
      </div>

      <Modal
        open={open}
        onClose={(e) => handleOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.ModalWrapper}>
          <div className={styles.ModalHead}>
            <h3 className={styles.modal_title}> Media Library </h3>
            <button
              className={styles.btnCloseModal}
              onClick={() => handleOpen(false)}
            >
              <FiX />
            </button>
          </div>

          <div className={styles.filter_form}>
            {!is_EnableForm && (
              <div className={styles.serachArea}>
                <div className={styles.search_left}>&nbsp;</div>

                <div className={styles.search_right}>
                  <div className={styles.form_group}>
                    <select
                      className={styles.formControl}
                      name="tag"
                      placeholder="Filter by Type"
                      onChange={handleInput}
                      value={searchFields.filter.tag}
                    >
                      {allowItem == "All" && (
                        <Fragment>
                          <option value="">All Media</option>
                          <option value="image">Image</option>
                          <option value="pdf">PDF</option>
                          <option value="video">Video</option>
                          <option value="audio">Audio</option>
                        </Fragment>
                      )}

                      {allowItem == "image" && (
                        <option value="image">Image</option>
                      )}

                      {allowItem == "pdf" && <option value="pdf">PDF</option>}

                      {allowItem == "video" && (
                        <option value="video">Video</option>
                      )}
                      {allowItem == "audio" && (
                        <option value="audio">Audio</option>
                      )}
                    </select>
                    <small className={styles.formLebel}>Filter by Type</small>
                  </div>
                  <div className={styles.form_group}>
                    <select
                      className={styles.formControl}
                      name="sortOrder"
                      placeholder="Filter by Type"
                      onChange={handleOrder}
                      value={searchFields.sortOrder}
                    >
                      <option value="DESC">DESC</option>
                      <option value="ASC">ASC</option>
                    </select>
                    <small className={styles.formLebel}>Short Order</small>
                  </div>
                  <div className={styles.form_group}>
                    <span className={styles.searchicon}>
                      <FaSearch />
                    </span>
                    <input
                      type="text"
                      autoComplete="off"
                      className={`${styles.formControl} ${styles.keyword_search} `}
                      name="mediaName"
                      placeholder="Search"
                      value={searchFields.searchText}
                      onChange={handleInput}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch();
                        }
                      }}
                      onBlur={(e) => handleSearch()}
                    />
                    <small className={styles.formLebel}>Filter by name</small>
                  </div>

                  <div className={styles.form_group}>
                    <button
                      size="small"
                      onClick={(e) => setEnableForm(true)}
                      type="button"
                      className="btn btn-primary"
                    >
                      <BsCloudUploadFill />
                      <span className="hide-sm">New</span>
                    </button>
                  </div>
                </div>
              </div>
            )}

            {is_EnableForm && (
              <div className={styles.serachArea}>
                <button
                  size="small"
                  onClick={(e) => setEnableForm(true)}
                  type="button"
                >
                  <BsFillGrid3X2GapFill /> &nbsp; Back to Galary
                </button>
              </div>
            )}
          </div>
          <div className={styles.ModalBody}>
            {!is_EnableForm && (
              <div className={styles.grid_container}>
                <div className={styles.grid_item}>
                  {mediaData &&
                    mediaData.length > 0 &&
                    mediaData.map((entity, index) => {
                      let slectedItem = selected.filter(
                        (item) => item.mediaManagerId == entity.mediaManagerId
                      );
                      return (
                        <MediaBox
                          data={entity}
                          key={`media_${entity.mediaManagerId}`}
                          onClick={imageChange}
                          is_selected={
                            slectedItem && slectedItem.length > 0 ? true : false
                          }
                        />
                      );
                    })}
                </div>
              </div>
            )}

            {is_EnableForm && (
              <MediaUPload
                onUploaded={handleUploaded}
                allowItem={allowItem}
                showTitle={false}
              />
            )}
          </div>
          <div className={styles.ModalFooter}>
            {!is_EnableForm && paginate.total > paginate.page_total && (
              <div className={styles.inputPager}>
                <PaginationComponent
                  paginate={paginate}
                  paginationHandler={paginationHandler}
                />
              </div>
            )}
            {!is_EnableForm && (
              <div className={styles.actions}>
                <button
                  className="btn btn-default"
                  type="button"
                  onClick={() => setOpen(false)}
                >
                  Close
                </button>
                {selected && selected.length > 0 && (
                  <button
                    className="btn btn-primary"
                    variant="contained"
                    onClick={handleInsert}
                    type="button"
                    size="small"
                  >
                    Insert
                  </button>
                )}
              </div>
            )}
            {is_EnableForm && (
              <button
                className="btn btn-default"
                onClick={() => setOpen(false)}
                type="button"
              >
                Close
              </button>
            )}
          </div>
        </Box>
      </Modal>
    </Fragment>
  );
};

export default MultipleFileInput;
